import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import styles from './style.css'
import * as actTableManagement from 'actions/tableManagement'
import {askConfirmAction} from 'actions/confirm-action'
import {isDirty} from 'redux-form'
import FilteredGroup from './FilteredGroup'

class List extends React.Component {
  render () {
    let {groupDetail, filteredGroups} = this.props
    return (filteredGroups && filteredGroups.length > 0 && <div className={styles.wrapper}>
      <table className={styles['table-header']}>
        <thead>
          <tr>
            <th className={styles.name}>Table Group</th>
            <th className={styles.name}>Status</th>
            <th className={styles.count}>Table Count</th>
            <th className={styles.name} />
          </tr>
        </thead>
      </table>
      <div className={styles['table-content-wrapper']}>
        <InfiniteScroll
          pageStart={1}
          useWindow={false}
          threshold={10}
          initialLoad={false}>
          <table className={styles['table-content']}>
            <tbody>
              {filteredGroups.map((group) => {
                return (
                  <FilteredGroup
                    group={group}
                    groupDetail={groupDetail}
                    onClickRow={this._onClickRow}
                    onDuplicateGroup={this._onDuplicateGroup}
                  />
                )
              })}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>)
  }

  _onClickRow = (group) => {
    const {isDirtyTableManagementGroup, dispatch} = this.props
    if (isDirtyTableManagementGroup) {
      dispatch(askConfirmAction(actTableManagement.onClickRow(group)))
    } else {
      dispatch(actTableManagement.onClickRow(group))
    }
  }

  _onDuplicateGroup = (group) => {
    const {groups, dispatch} = this.props
    dispatch(askConfirmAction(actTableManagement.duplicateGroup(group, groups), {
      bodyText: 'Confirm To Duplicate Table Group?',
      titleText: 'Duplicate Table Group',
      okText: 'Duplicate',
      cancelText: 'Cancel'
    }))
  }
}

function mapStateToProps (state) {
  const {groups, currentPage, totalPage, groupDetail, filteredGroups} = state.tableManagement.group
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const isDirtyTableManagementGroup = isDirty('table-management-group')(state)
  return {
    groups,
    filteredGroups,
    currentPage,
    totalPage,
    groupDetail,
    showLoadingSpinnerPage,
    isDirtyTableManagementGroup
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  groups: React.PropTypes.array,
  filteredGroups: React.PropTypes.array,
  groupDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementGroup/List/List.js